export default {
    heading: 'Eloquia, InterVariable, -apple-system, system-ui, sans-serif',
    body: 'Eloquia, InterVariable, -apple-system, system-ui, sans-serif'
};
